<app-closeable-dialog-title
  [allowMaximize]="false"
  [title]="(data.keyword && data.keyword.id) ? 'Edit keyword': 'Add keyword'">
</app-closeable-dialog-title>

<div mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Keyword</mat-label>
      <input matInput formControlName="keyword"
             (blur)="loadSynonyms()"/>
    </mat-form-field>
    @if (loadingSynonyms) {
      <p>Loading initial synonyms </p>
    }
    <mat-form-field class="full-width">
      <mat-label>Synonyms</mat-label>
      <mat-chip-grid #chipGrid aria-label="Enter Synonym">
        @for (synonym of data.keyword?.synonyms; track synonym) {
          <mat-chip-row
            (removed)="removeSynonym(synonym)"
            [editable]="true"
            (edited)="editSynonym(synonym, $event)"
            [aria-description]="'press enter to edit ' + synonym"
          >
            {{ synonym }}
            <button matChipRemove [attr.aria-label]="'remove ' + synonym">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
        <input
          placeholder="New Synonym..."
          [disabled]="loadingSynonyms"
          [matChipInputFor]="chipGrid"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="addSynonym($event)"
        />
      </mat-chip-grid>
    </mat-form-field>
    @if (loadingSynonyms) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </form>

</div>

<div mat-dialog-actions class="actions">
  @if (data.keyword && data.keyword.id) {
    <button mat-raised-button class="delete-btn" (click)="delete()">
      <mat-icon>delete</mat-icon>
      Delete
    </button>
  }
  <span class="spacer"></span>
  <button mat-raised-button class="save-btn" [disabled]="form.invalid" (click)="save()">
    <mat-icon>save</mat-icon>
    Save
  </button>
</div>
